import {
  getMaxDownstreamDatasources,
  getMaxDownstreamWorkbooks,
  MaxCountsResultData
} from '@tableau/data-catalog-shared';
import { DatabasesByTagQuery } from '../../../../gen-src/queries/DatabasesByTagQuery';
import { DenormalizedVirtualConnectionRowData } from '../types/VirtualConnectionDisplayGridRowData';

export function getRowDataWithMaxCountsForVirtualConnection<D>(
  database: D,
  resultData: MaxCountsResultData | null,
): D & DenormalizedVirtualConnectionRowData {
  return {
    ...database,
    contentType: 'virtualConnection',
    maxDownstreamDatasources: getMaxDownstreamDatasources(resultData),
    maxDownstreamWorkbooks: getMaxDownstreamWorkbooks(resultData),
  };
}

export function getRowDataWithMaxCountsForVirtualConnectionWithTagFilter<D>(
  database: D,
  resultData: DatabasesByTagQuery | null,
): D & DenormalizedVirtualConnectionRowData {
  const tag = resultData && resultData.tags && resultData.tags[0];
  return getRowDataWithMaxCountsForVirtualConnection(database, tag);
}
